// FIN-HUBS: Recebimentos — Contas a Receber + Medições (BM) + Deliberação.
import HubAbas, { HubTab } from '../../components/HubAbas';
import FinanceiroContasReceber from '../FinanceiroContasReceber';
import FinanceiroMedicoes from '../FinanceiroMedicoes';
import FinanceiroDeliberacao from '../FinanceiroDeliberacao';

const TABS: HubTab[] = [
  { key: 'contas-receber', label: 'Contas a Receber', perm: 'financeiro.contas_receber.ver', render: () => <FinanceiroContasReceber /> },
  { key: 'medicoes',       label: 'Medições (BM)',    perm: 'financeiro.medicoes_bm.ver',    render: () => <FinanceiroMedicoes /> },
  // Deliberação era item G_ADMIN no menu antigo — mantém a restrição na aba.
  { key: 'deliberacao',    label: '⚖️ Deliberação',    perm: 'financeiro.contas_receber.ver', soAdmin: true, render: () => <FinanceiroDeliberacao /> },
];

export default function FinanceiroRecebimentosHub() {
  return <HubAbas tabs={TABS} />;
}
